<template>
  <div>
    <top></top>
    <router-view></router-view>
    <bottom v-if="$route.name != 'Trade'&&$route.name != 'Chat'&&$route.name != 'MySelect'"></bottom>
  </div>
</template>

<script>
import top from '../components/top'
import bottom from '../components/bottom'
export default {
  name: 'index',
  components: {
    top,
    bottom
  },

  data() {
    return {}
  },

  mounted() { },

  methods: {}
}
</script>

<style lang="less">
* {
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+ */
  user-select: none;
  /* Standard syntax */
  cursor: pointer;
}
</style>
